// extracted by mini-css-extract-plugin
module.exports = {"bannerRowWrapper":"PromotionalBanner_bannerRowWrapper__1_taC","bannerLeftColumn":"PromotionalBanner_bannerLeftColumn__2uSwI"};